
import auth from './auth';
import user from './user';
import member from './member';
import organization from './organization';
import department from './department';
import deptAppr from './deptAppr';
import group from './group';
import deptMember from './deptMember';
import groupDeptMember from './groupDeptMember';
import channelUser from './channelUser';
import deptUser from './deptUser';
import channel from './channel';
import asset from './asset';
import audit from './audit';
import my from './my';
import groupSubs from './groupSubs';
import grantAsset from './grantAsset';
import deptMbrSubs from './deptMbrSubs';
import subscribe from './subscribe';
import chnlWhitelist from "./chnlWhitelist";
import chnlOrgWhitelist from "./chnlOrgWhitelist";
import recshare from "./recshare";
import recshareUser from "./recshareUser";
import recshareMember from "./recshareMember";
import recshareAppr from "./recshareAppr";
import latest from "./latest";

export default {
  latest,
  auth,
  user,
  member,
  organization,
  department,
  deptAppr,
  grantAsset,
  group,
  deptMember,
  groupDeptMember,
  channelUser,
  deptUser,
  asset,
  audit,
  my,
  channel,
  groupSubs,
  deptMbrSubs,
  subscribe,
  chnlWhitelist,
  chnlOrgWhitelist,
  recshare,
  recshareUser,
  recshareMember,
  recshareAppr,
}
